import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-w.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-w.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CreateApplicationLocationWConstants } from "./create-application-location-w.constants";
import { MapTools } from "../../../../../map/shared/map.tools";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CreateApplicationLocationTpamsConstants } from "../../tp/create-application-location-tpams/create-application-location-tpams.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import GeometryUtils from "../../../../../shared/utils/geometry-utils";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let CreateApplicationLocationWComponent = class CreateApplicationLocationWComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    mapTools;
    changeDetectorRefs;
    locationForm;
    descriptionLabel1 = CreateApplicationLocationWConstants.DESCRIPTION_LABEL_1;
    mapComponent;
    sketch;
    selectedGraphic = null;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, appController, mapTools, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        // if (this.createApplicationService.applicationData) {
        //   this.createApplicationService.applicationData = null;
        // }
        this.changeDetectorRefs.detectChanges();
    }
    mapLoaded() {
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.mapTools.expandWidget("drawTool");
        this.sketch.create("polygon");
        this.loadExistingApplication();
        this.sketch.on("create", (event) => {
            if (event.state === "complete") {
                this.selectedGraphic = event.graphic;
                this.locationForm.get("selectedGraphic").setValue(this.selectedGraphic);
                if (event.graphic.geometry.type === "point") {
                    this.locationForm.get("centroid").setValue(event.graphic.geometry);
                    this.locationForm.get("polygon").setValue(null);
                    this.locationForm.get("polyline").setValue(null);
                }
                else {
                    const proxyUrl = ApiProxyConstants.URL;
                    const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                    const url = `${proxyUrl}?${gpToolUrl}`;
                    const formData = new FormData();
                    formData.append("f", "json");
                    formData.append("geometryJSON", JSON.stringify(event.graphic.geometry));
                    this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                        .subscribe({
                        next: (trueCentroidResponse) => {
                            this.locationForm.get("centroid").setValue(trueCentroidResponse.results[0].value);
                            if (event.graphic.geometry.type === "polygon") {
                                this.locationForm.get("polygon").setValue(event.graphic.geometry);
                            }
                            else if (event.graphic.geometry.type === "polyline") {
                                this.locationForm.get("polyline").setValue(event.graphic.geometry);
                            }
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                        }
                    });
                }
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
        if (this.locationForm.get("selectedGraphic").value !== null) {
            this.selectedGraphic = this.locationForm.get("selectedGraphic").value;
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.selectedGraphic.geometry)], "Draw Tool Layer");
        }
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("locationForm");
        this.locationForm = form;
    }
    loadExistingApplication() {
        const application = this.createApplicationService.applicationData;
        if (application) {
            const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.shape, 102100);
            const centroid = JsonUtils.fromJSON(centroidGeometryArc);
            const geometries = [];
            this.locationForm.get("centroid").setValue(centroid);
            let showPoint = true;
            if (application.applicationPolygons.length > 0) {
                showPoint = false;
                const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.applicationPolygons[0].shape, 102100);
                const polygon = JsonUtils.fromJSON(polygonGeometryArc);
                this.locationForm.get("polygon").setValue(polygon);
                this.locationForm.get("polygonDto").setValue(application.applicationPolygons[0]);
                geometries.push(polygon);
            }
            else {
                this.locationForm.get("polygon").setValue(null);
                this.locationForm.get("polygonDto").setValue(null);
            }
            if (application.applicationLines.length > 0) {
                showPoint = false;
                const polylineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.applicationLines[0].shape, 102100);
                const polyline = JsonUtils.fromJSON(polylineGeometryArc);
                this.locationForm.get("polyline").setValue(polyline);
                this.locationForm.get("polylineDto").setValue(application.applicationLines[0]);
                geometries.push(polyline);
            }
            else {
                this.locationForm.get("polyline").setValue(null);
                this.locationForm.get("polylineDto").setValue(null);
            }
            if (showPoint) {
                geometries.push(centroid);
            }
            this.mapComponent.addGeometriesOnMap(geometries, "Draw Tool Layer", true);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: MapTools },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationWComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-w",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationWComponent);
export { CreateApplicationLocationWComponent };
